import { useState } from "react";
import { Button, Divider, Form, Icon, Input } from "semantic-ui-react";

import InputComponents from "../../components/InputComponents/InputComponents";
import { useDispatch } from "react-redux";
import { loading, loadingDestroy, notice } from "../../redux/action/action";
import { cryptData } from "../../utils/encryptData";
import { COMMON_LOADING } from "../../constant";
import { useLocation, useNavigate, useParams } from "react-router";
import { storeMemberInfo } from "../../redux/action/member/memberAction";
import { useTranslation } from "react-i18next";
import { actionSignIn, verifiedRobotBoy } from "../../api/postApi";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { getUserGameList, getUserInfo } from "../../api/getApi";
import GoogleLoginButton from "./components/googleLogin";
import { filterGameList } from "../../redux/action/game/gameAction";
import { InitializeApi } from "../../api/initializeApi";
import ReCAPTCHA from "react-google-recaptcha";
import CustomTurnstile from "./components/customTurnstile";
import { useEffect } from "react";
import useGetAgentName from "../../hook/useGetAgentName";
import TelegramLogin from "./components/telegramLogin";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import RegisterAgent from "./components/registerAgent";

const MailSignin = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`header.${key}`);
  const i18n_common_form = (key) => t(`settings.form.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const [watchPassword, setWatchPassword] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [data, setData] = useState({});
  const { loginName, password } = data;
  const [dataFocus, setDataFocus] = useState({});
  const [isVerify, setIsVerify] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  const handleLoginUser = (e) => {
    e.preventDefault();
    dispatch(loading());
    setButtonLoading(true);

    actionSignIn({
      account: loginName,
      passwd: password,
    })
      .then((data) => {
        dispatch(notice(i18n_backend_response("Login Success"), "success"));
        if (Cookies.get("token")) {
          Cookies.remove("token");
        }
        Cookies.set("token", data.token, { expires: 3 });

        dispatch({
          type: "INITIALIZE_API",
          navigate: navigate,
          tmpToken: data.tmpToken,
        });

        navigate("/casino");
      })
      .catch((err) => {})
      .finally(() => {
        setButtonLoading(false);
        dispatch(loadingDestroy());
      });
  };

  const inputList = [
    {
      label: i18n_common_form("account"),
      name: "loginName",
      type: "text",
      onChange: (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
      },
    },
    {
      label: i18n_common_form("password"),
      name: "password",
      type: watchPassword ? "text" : "password",
      needIcon: true,
      icon1: watchPassword ? "eye slash" : "eye",
      function: () => setWatchPassword(!watchPassword),
      onChange: (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
      },
    },
  ];

  return (
    <Form onSubmit={handleLoginUser}>
      <section>
        {inputList.map((input, index) => {
          return (
            <>
              <label className="text-base text-sm text-base-dark dark:text-base-light-white">
                {input.label}
              </label>
              <InputComponents
                focusProps={dataFocus}
                dataProps={data}
                setDataProps={setData}
                inputProps={input}
                index={index}
                className="!p-[12px]"
              />
            </>
          );
        })}
        <RegisterAgent />
        <CustomTurnstile setIsVerify={setIsVerify} />
        {process.env.REACT_APP_SECRET_TYPE === "local" ? (
          <Button
            size="xl"
            className="w-full !bg-main-color !mt-[30px] !text-white !py-[15px]"
            disabled={buttonLoading}
            loading={buttonLoading}
            type="submit"
          >
            {i18n("signin")}
          </Button>
        ) : (
          <Button
            size="xl"
            className="w-full !bg-main-color !mt-[30px] !text-white !py-[15px]"
            disabled={buttonLoading || !isVerify}
            loading={buttonLoading}
            type="submit"
          >
            {i18n("signin")}
          </Button>
        )}
        <GoogleLoginButton
          setButtonLoading={setButtonLoading}
          buttonLoading={buttonLoading}
        />
        <TelegramLogin
          setButtonLoading={setButtonLoading}
          buttonLoading={buttonLoading}
        />
      </section>
    </Form>
  );
};

export default MailSignin;
